import React from 'react';
import ReactDOM from 'react-dom';
import {
	useNavigationType,
	matchRoutes,
	useLocation,
	createRoutesFromChildren
} from 'react-router-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import { BrowserTracing } from '@sentry/tracing';
import { Provider } from 'react-redux';
import store from './store';
import * as Sentry from '@sentry/react';

let environment = 'development';
if (window.location.href.includes('www-stage.vizio.com')) {
	environment = 'staging';
} else if (window.location.href.includes('www-preprod.vizio.com')) {
	environment = 'preprod';
} else if (window.location.href.includes('www.vizio.com')) {
	environment = 'production';
}

Sentry.init({
	dsn: 'https://f82efd63e5a4e6d7ee492df06167c240@o401343.ingest.us.sentry.io/4508484707614720',
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes
		})
	],
	enableTracing: true,
	tracesSampleRate: 0.25,
	environment: environment
});

ReactDOM.render(
	<React.StrictMode>
		<Sentry.ErrorBoundary fallback={<div>Something went wrong. Please try again.</div>}>
			<Provider store={store}>
				<App />
			</Provider>
		</Sentry.ErrorBoundary>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
